import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { util } from '../../util/util';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentRestService {
  constructor(protected restService: RestService) {}

  getDocument(documentId: string, customerIds: string[]): Observable<object> {
    let url = `/Document/get?DocumentId=${documentId}`;
    if (customerIds && customerIds.length) {
      url += '&' + util.serializeObjectToParams({ customerId: customerIds });
    }
    return this.restService.getBlobData(url);
  }

  getCCRDocument(ccrDocumentNumber: string): Observable<object> {
    return this.restService.getBlobData(`/Ccr/getCcrDocument?CcrNumber=${ccrDocumentNumber}`);
  }
}
